import { FC, MouseEvent, ReactNode } from 'react';
import styles from './styles.module.scss';
import CloseButton from '../../../../../components/CloseButton';

export type TModalContentProps = {
  onMouseDown: (e: MouseEvent) => void;
  onClick: (e: MouseEvent) => void;
  onClose: VoidFunction;
  children: ReactNode;
};

const ModalContent: FC<TModalContentProps> = ({ onClick, onMouseDown, children, onClose }) => {
  return (
    <div className={styles.overlay} onMouseDown={onMouseDown} onClick={onClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modal}>
          <CloseButton color="blue" onClick={onClose} className={styles.close} size={31} tabletIconSize={8} iconSize={10} tabletSize={24} />
          <div className={styles.modalContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalContent;
